import { render, staticRenderFns } from "./SumupScoreDistributionList.vue?vue&type=template&id=808f6fce&"
import script from "./SumupScoreDistributionList.vue?vue&type=script&lang=ts&"
export * from "./SumupScoreDistributionList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports